import { scrollToElement } from './helper-functions/scrollToElement';

export const initScrollToAnchor = () => {
    const links = document.querySelectorAll('[data-anchor-link]');
    if (!links.length) return;

    links.forEach((link) => {
        link.addEventListener('click', handleOnClickLink, false);
    });

    function handleOnClickLink(event) {
        event.preventDefault();
        closeBurger();
        scrollToElement(this.getAttribute('href'), -150, true);
    }

    function closeBurger() {
        const menu = document.querySelector('[data-header-nav]');
        if (!menu) return;

        if (menu.classList.contains('--active')) {
            menu.classList.remove('--active');
        }
    }
};
